import axios from "axios";
import router from "../router/index";
import store from "../store";
import Vue from "vue";

let base = "";
export default {
  uploadUrl: "http://mgdv3.api.shengxuemap.cn",
};

let userInfo = {}

if (window.localStorage.getItem("user")) {
  userInfo = JSON.parse(window.localStorage.getItem("user"))
}
console.log(userInfo, 'aaaa222222222')

let RequestSource = 2;
let StudentId = 0;
let SysUserId = userInfo.uID;
// let params = {
//   ...RequestSource,
//   ...StudentId,
//   ...SysUserId,
// }
// 请求延时
axios.defaults.timeout = 20000;
let TokenExpire;
let token;
axios.interceptors.request.use(
  (config) => {
    token = window.localStorage.getItem("Token");
    TokenExpire = window.localStorage.getItem("TokenExpire");
    var curTime = new Date();
    var expiretime = new Date(Date.parse(TokenExpire));
    if (token && (curTime < expiretime && TokenExpire)) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.Authorization = "Bearer " + token;
    }
    // console.log(config, 'config')
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

// http response 拦截器

axios.interceptors.response.use(
  (response) => {
    if (response.status == 401) {
      ToLogin();
    }
    return response;
  },
  (error) => {
    //console.log(error, "网络错误");
    let errInfo = {
      success: false,
      message: "错误",
    };
    // 超时请求处理
    var originalRequest = error.config;
    if (
      error.code == "ECONNABORTED" &&
      error.message.indexOf("timeout") != -1 &&
      !originalRequest._retry
    ) {
      errInfo.message = "请求超时！";
      originalRequest._retry = true;
    } else if (error.response) {
      if (error.response.status == 500) {
        ToLogin();
      }

      if (error.response.status == 401) {
        var curTime = new Date();
        var refreshtime = new Date(Date.parse(window.localStorage.refreshtime)); //登录是返回的expires_in
        // 在用户操作的活跃期内
        if (window.localStorage.refreshtime && curTime <= refreshtime) {
          return refreshToken({
            token: window.localStorage.Token,
          }).then((res) => {
            if (res.success) {
              store.commit("saveToken", res.response.token);
              var curTime = new Date();
              var expiredate = new Date(
                curTime.setSeconds(
                  curTime.getSeconds() + res.response.expires_in
                )
              );
              store.commit("saveTokenExpire", expiredate);
              error.config.__isRetryRequest = true;
              error.config.headers.Authorization =
                "Bearer " + res.response.token;
              return axios(error.config);
            } else {
              // 刷新token失败 清除token信息并跳转到登录页面
              ToLogin();
            }
          });
        } else {
          // 返回 401，并且不在用户操作活跃期内 清除token信息并跳转到登录页面
          ToLogin();
        }
      }
      // 403 无权限
      else if (error.response.status == 403) {
        errInfo.message = "失败！该操作无权限";
      }
      // 429 ip限流
      else if (error.response.status == 429) {
        errInfo.message = "刷新次数过多，请稍事休息重试！";
      } else if (error.response.status == 404) {
        // 404 不存在
        errInfo.message = "失败！访问接口不存在";
      } else if (error.response.status == 500) {
        // 500 服务器异常
        errInfo.message = "失败！服务器异常";
      } else if (error.response.status == 405) {
        // 405 请求http方法错误
        errInfo.message = "失败！请求http方法错误";
      } else if (error.response.status == 415) {
        // 415 参数没有指定Body还是Query
        errInfo.message = "失败！参数没有指定Body还是Query";
      } else {
        //其他错误参数
        errInfo.message = "失败！请求错误" + error.response.status;
      }
    } else {
      errInfo.message = "失败！服务器断开";
    }
    Vue.prototype.$message({
      message: errInfo.message,
      type: "error",
      offset: 120,
    });
    return errInfo; // 返回接口返回的错误信息
  }
);

const ToLogin = (params) => {
  store.commit("saveToken", "");
  store.commit("saveTokenExpire", "");
  store.commit("saveTagsData", "");
  window.localStorage.removeItem("user");
  window.localStorage.removeItem("NavigationBar");
  router.replace({
    path: "/login",
    query: {
      redirect: router.currentRoute.fullPath,
    },
  });
};
// 登录
export const requestLogin = (params) => {
  return axios
    .get(`${base}/api/Login/JWTToken5.0`, {
      params: params,
    })
    .then((res) => res.data);
};
export const GetTokenUserListByJWT5 = (params) => {
  return axios
    .get(`${base}/api/Login/GetTokenUserListByJWT5`, {
      params: params,
    })
    .then((res) => res.data);
};
/**
 * 获取用户信息
 * @param {*} params
 * @returns
 */
export const getUserByToken = (params) => {
  return axios
    .get(`${base}/api/user/getInfoByToken`, {
      params: params,
    })
    .then((res) => res.data);
};
/**
 * 刷新token
 * @param {*} params
 * @returns
 */
export const refreshToken = (params) => {
  return axios
    .get(`${base}/api/login/RefreshToken`, {
      params: params,
    })
    .then((res) => res.data);
};

/**
 * 获取动态路由
 * @param {*} params
 * @returns
 */
export const getNavigationBar = (params) => {
  return axios
    .get(`${base}/api/permission/GetNavigationBar`, {
      params: params,
    })
    .then((res) => res.data);
};
// 角色管理
export const getRoleListPage = (params) => {
  return axios.get(`${base}/api/role/get`, {
    params: params,
  });
};
export const removeRole = (params) => {
  return axios.delete(`${base}/api/role/delete`, {
    params: params,
  });
};
export const editRole = (params) => {
  return axios.put(`${base}/api/role/put`, params);
};

export const saveRefreshtime = (params) => {
  let nowtime = new Date();
  let lastRefreshtime = window.localStorage.refreshtime ?
    new Date(window.localStorage.refreshtime) :
    new Date(-1);
  let expiretime = new Date(Date.parse(window.localStorage.TokenExpire));

  let refreshCount = 1; //滑动系数
  if (lastRefreshtime >= nowtime) {
    lastRefreshtime = nowtime > expiretime ? nowtime : expiretime;
    lastRefreshtime.setMinutes(lastRefreshtime.getMinutes() + refreshCount);
    window.localStorage.refreshtime = lastRefreshtime;
  } else {
    window.localStorage.refreshtime = new Date(-1);
  }
};
// 菜单模块管理
export const getPermissionTree = (params) => {
  return axios.get(`${base}/api/permission/getpermissiontree`, {
    params: params,
  });
};
export const getPermissionIds = (params) => {
  return axios.get(`${base}/api/permission/GetPermissionIdByRoleId`, {
    params: params,
  });
};
export const removePermission = (params) => {
  return axios.delete(`${base}/api/permission/delete`, {
    params: params,
  });
};
export const editPermission = (params) => {
  return axios.put(`${base}/api/permission/put`, params);
};
export const addPermission = (params) => {
  return axios.post(`${base}/api/permission/post`, params);
};
export const addRolePermission = (params) => {
  return axios.post(`${base}/api/permission/Assign`, params);
};
export const getPermissionTreeTable = (params) => {
  return axios.get(`${base}/api/permission/GetTreeTable`, {
    params: params,
  });
};
// 接口模块管理
export const getModuleListPage = (params) => {
  return axios.get(`${base}/api/module/get`, {
    params: params,
  });
};
export const removeModule = (params) => {
  return axios.delete(`${base}/api/module/delete`, {
    params: params,
  });
};
export const editModule = (params) => {
  return axios.put(`${base}/api/module/put`, params);
};

export const addModule = (params) => {
  return axios.post(`${base}/api/module/post`, params);
};
// 用户管理
export const getUserListPage = (params) => {
  return axios.get(`${base}/api/user/get`, {
    params: params,
  });
};
export const removeUser = (params) => {
  return axios.delete(`${base}/api/user/delete`, {
    params: params,
  });
};
export const editUser = (params) => {
  return axios.put(`${base}/api/user/put`, params);
};
export const batchRemoveUser = (params) => {
  return axios.delete(`${base}/api/Claims/BatchDelete`, {
    params: params,
  });
};
export const addUser = (params) => {
  return axios.post(`${base}/api/user/post`, params);
};
export const requestLoginMock = (params) => {
  return axios.post(`${base}/login`, params).then((res) => res.data);
};
export const addRole = (params) => {
  return axios.post(`${base}/api/role/post`, params);
};
//省市区获取
export const GetRegionList = (params) => {
  return axios.get(`${base}/api/back/School/GetRegionList`, {
    params: params,
  });
};
//学校管理
//添加
export const AddSchoolInfo = (params) => {
  return axios.post(`${base}/api/back/School/AddSchoolInfo`, params);
};
//删除
export const DeleteSchoolInfo = (params) => {
  return axios.post(`${base}/api/back/School/DeleteSchoolInfo`, params);
};
//更新
export const UpdateSchoolInfo = (params) => {
  return axios.post(`${base}/api/back/School/UpdateSchoolInfo`, params);
};
//查询学校分页
export const GetSchoolInfoByPage = (params) => {
  return axios.get(`${base}/api/back/School/GetSchoolInfoByPage`, {
    params: params,
  });
};
//查询单条
export const GetSchoolInfoOne = (params) => {
  return axios.get(`${base}/api/back/School/GetSchoolInfoOne`, {
    params: params,
  });
};
//添加天数
export const AddDayNum = (params) => {
  return axios.post(`${base}/api/back/School/AddDayNum`, params);
};

export const GetRelationInfo = (params) => {
  return axios.get(`${base}/api/User/GetRelationInfo`, {
    params: params,
  });
};
export const GetSchoolList = (params) => {
  return axios.get(`${base}/api/back/School/GetSchoolList`, {
    params: params,
  });
};
//周期管理 列表  查询
export const GetCycleTimeInfoByPage = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetCycleTimeInfoByPage`, {
    params: params,
  });
};
//学界管理 下拉列表
export const getAcademicSelect = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetStudyYearSelectResult`, {
    params: params,
  });
};
//周期管理 列表  开启
export const LifeCycleOpen = (params) => {
  return axios.post(`${base}/api/back/Bs_Tenants/OpenCycleInfo`, params);
};
////年级管理 列表以及下拉接口
export const GetGradeList = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetGradeSelect`, {
    params: params,
  });
};
export const AddCycleInfo = (params) => {
  return axios.post(`${base}/api/back/SchoolInfo/AddCycleTimeInfo`, params);
};
export const UpdateCycleInfo = (params) => {
  return axios.post(`${base}/api/back/Bs_Tenants/UpdateCycleInfo`, params);
};
export const DeleteCycleInfo = (params) => {
  return axios.post(`${base}/api/back/SchoolInfo/DeleteCycleTimeInfo`, params);
};
export const UpdateCycleTimeInfo = (params) => {
  return axios.post(`${base}/api/back/SchoolInfo/UpdateCycleTimeInfo`, params);
};
export const GetStudyYearsInfoByPage = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetStudyYearsInfoByPage`, {
    params: params,
  });
};
export const UpdateStudyYearInfo = (params) => {
  return axios.post(`${base}/api/back/SchoolInfo/UpdateStudyYearInfo`, params);
};
export const GetTeacherInfo = (params) => {
  return axios.get(`${base}/api/back/TeacherInfo/GetTeacherInfo`, {
    params: params,
  });
};
export const AddStudyYearsInfo = (params) => {
  return axios.post(`${base}/api/back/SchoolInfo/AddStudyYearsInfo`, params);
};
export const GetTeacher2User = (params) => {
  return axios.get(`${base}/api/back/TeacherInfo/GetTeacher2User`, {
    params: params,
  });
};
export const GetStudent2User = (params) => {
  return axios.get(`${base}/api/back/Student/GetStudent2User`, {
    params: params,
  });
};
export const GetUserBandList = (params) => {
  return axios.get(`${base}/api/back/TeacherInfo/GetUserBandList`, {
    params: params,
  });
};
export const BandUser = (params) => {
  return axios.post(`${base}/api/back/TeacherInfo/BandUser`, params);
};
export const StudentBandUser = (params) => {
  return axios.post(`${base}/api/back/Student/BandUser`, params);
};
export const GetCycleInfoSelectResult = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetCycleInfoSelectResult`, {
    params: params,
  });
};
export const GetClassSelect = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetClassSelect`, {
    params: params,
  });
};
export const GetStudentByPage = (params) => {
  return axios.get(`${base}/api/back/Student/GetStudentByPage`, {
    params: params,
  });
};
export const Addf_teacherinfo = (params) => {
  return axios.post(`${base}/api/back/TeacherInfo/Addf_teacherinfo`, params);
};
export const Updatef_teacherinfo = (params) => {
  return axios.post(`${base}/api/back/TeacherInfo/Updatef_teacherinfo`, params);
};
export const Addf_studentinfo = (params) => {
  return axios.post(`${base}/api/back/Student/Addf_studentinfo`, params);
};
export const GetClassList = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetClassList`, {
    params: params,
  });
};
export const Updatef_studentinfo = (params) => {
  return axios.post(`${base}/api/back/Student/Updatef_studentinfo`, params);
};
export const AddClassInfo = (params) => {
  return axios.post(`${base}/api/back/SchoolInfo/AddClassInfo`, params);
};
export const UpdateClassInfo = (params) => {
  return axios.post(`${base}/api/back/SchoolInfo/UpdateClassInfo`, params);
};
export const DelClassInfo = (params) => {
  return axios.post(`${base}/api/back/SchoolInfo/DelClassInfo`, params);
};
//文件导入Excel  /api/OtherFile/File/UploadFileExcel
export const FileUploadsExcel = (params) => {
  return axios.post(`${base}/import/ImportInfo/UploadFileExcel`, params);
};
//导入老师
export const ImportTeacherinfo = (params) => {
  return axios.post(`${base}/import/ImportInfo/ImportTeacherinfo`, params);
};
export const ImportStudent = (params) => {
  return axios.post(`${base}/import/ImportInfo/ImportStudent`, params);
};
export const GetClassRole = (params) => {
  return axios.get(`${base}/api/back/UserManage/GetClassRole`, {
    params: params,
  });
};
export const AddUserClassRole = (params) => {
  return axios.post(`${base}/api/back/UserManage/AddUserClassRole`, params);
};
export const GetPhysicalExaminationList = (params) => {
  // return axios.get(
  //   `${base}/api/mgd/He_PhysicalExaminationControlle/GetPhysicalExaminationList`, {
  //     params: params,
  //   }
  // );
  return axios.post(`${base}/api/mgd/He_PhysicalExaminationControlle/GetPhysicalExaminationList`, params);
};
export const AddPhysicalExamination = (params) => {
  return axios.post(
    `${base}/api/mgd/He_PhysicalExaminationControlle/AddPhysicalExamination`,
    params
  );
};
export const DelPhysicalExamination = (params) => {
  return axios.post(
    `${base}/api/mgd/He_PhysicalExaminationControlle/DelPhysicalExamination`,
    params
  );
};
export const setUpdateClassInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/He_PhysicalExaminationControlle/UpdateClassInfo`,
    params
  );
};
export const ImportPhysicalExamination = (params) => {
  return axios.post(
    `${base}/import/ImportInfo/ImportPhysicalExamination`,
    params
  );
};
export const GetPhysicalExamination2SpecialList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_PhysicalExaminationControlle/GetPhysicalExamination2SpecialList`, {
      params: params,
    }
  );
};
export const GetFoodTypeList = (params) => {
  return axios.get(`${base}/api/mgd/He_FoodControlle/GetFoodTypeList`, {
    params: params,
  });
};
export const GetTypeList = (params) => {
  return axios.get(`${base}/api/mgd/He_FoodControlle/GetTypeList`, {
    params: params,
  });
};
export const GetHe_FoodLibraryList = (params) => {
  return axios.get(`${base}/api/mgd/He_FoodControlle/GetHe_FoodLibraryList`, {
    params: params,
  });
};
export const UpdateHe_FoodLibrary = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodControlle/UpdateHe_FoodLibrary`,
    params
  );
};
export const ImportHe_FoodLibrary = (params) => {
  // return axios.post(`${base}/api/mgd/He_FoodControlle/ImportHe_FoodLibrary`, params);
  return axios.post(`${base}/import/ImportInfo/ImportHe_FoodLibrary`, params);
};
export const GetFoodDishList = (params) => {
  return axios.get(`${base}/api/mgd/He_FoodDishControlle/GetFoodDishList`, {
    params: params,
  });
};
export const AddHe_FoodDish = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodDishControlle/AddHe_FoodDish`,
    params
  );
};
export const GetFoodLibraryList = (params) => {
  return axios.get(`${base}/api/mgd/He_FoodDishControlle/GetFoodLibraryList`, {
    params: params,
  });
};
// 删除菜肴
export const DelHe_FoodDish = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodDishControlle/DelHe_FoodDish`,
    params
  );
};
export const UpdateHe_FoodDish = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodDishControlle/UpdateHe_FoodDish`,
    params
  );
};
export const GetHe_FoodRecipesList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodDishControlle/GetHe_FoodRecipesList`, {
      params: params,
    }
  );
};
export const DelHe_FoodRecipes = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodDishControlle/DelHe_FoodRecipes`,
    params
  );
};
export const GetHe_FoodDishList = (params) => {
  return axios.get(`${base}/api/mgd/He_FoodDishControlle/GetHe_FoodDishList`, {
    params: params,
  });
};
export const AddHe_FoodRecipes = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodDishControlle/AddHe_FoodRecipes`,
    params
  );
};
export const UpdateHe_FoodRecipes = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodDishControlle/UpdateHe_FoodRecipes`,
    params
  );
};
export const GetHe_FoodPersonList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodPersonControlle/GetHe_FoodPersonList`, {
      params: params,
    }
  );
};
export const GetClassDetailInfoList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodPersonControlle/GetClassDetailInfoList`, {
      params: params,
    }
  );
};
export const AddHe_FoodPerson = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodPersonControlle/AddHe_FoodPerson`,
    params
  );
};
export const GetHe_FoodPersonDetailList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodPersonControlle/GetHe_FoodPersonDetailList`, {
      params: params,
    }
  );
};
export const UpdateHe_FoodPerson = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodPersonControlle/UpdateHe_FoodPerson`,
    params
  );
};
export const DelHe_FoodPerson = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodPersonControlle/DelHe_FoodPerson`,
    params
  );
};
export const GetHe_FoodEverydayList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodEverydayControlle/GetHe_FoodEverydayList`, {
      params: params,
    }
  );
};
export const GetHe_FoodEverydayDetailList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodEverydayControlle/GetHe_FoodEverydayDetailList`, {
      params: params,
    }
  );
};
export const AddHe_FoodEveryDayDetail = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodEverydayControlle/AddHe_FoodEveryDayDetail`,
    params
  );
};
export const DelHe_FoodEveryDayDetail = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodEverydayControlle/DelHe_FoodEveryDayDetail`,
    params
  );
};
export const UpdateHe_FoodEveryDayDetail = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodEverydayControlle/UpdateHe_FoodEveryDayDetail`,
    params
  );
};
export const DelHe_FoodEveryDay = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodEverydayControlle/DelHe_FoodEveryDay`,
    params
  );
};
export const ImportHe_FoodEveryDay = (params) => {
  return axios.post(`${base}/import/ImportInfo/ImportHe_FoodEveryDay`, params);
};
export const GetHe_FoodEverydayListNext = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodEverydayControlle/GetHe_FoodEverydayListNext`, {
      params: params,
    }
  );
};
export const ImportHe_FoodEveryDayNext = (params) => {
  return axios.post(
    `${base}/import/ImportInfo/ImportHe_FoodEveryDayNext`,
    params
  );
};
export const GetHe_FoodEverydayDetailListNext = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodEverydayControlle/GetHe_FoodEverydayDetailListNext`, {
      params: params,
    }
  );
};
export const AddHe_FoodEveryDayDetailNext = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodEverydayControlle/AddHe_FoodEveryDayDetailNext`,
    params
  );
};
export const GetHe_FoodRecipesEveryWeekList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodEverydayControlle/GetHe_FoodRecipesEveryWeekList`, {
      params: params,
    }
  );
};
export const AddHe_FoodRecipesEveryWeek = (params) => {
  return axios.post(
    `${base}/api/mgd/He_FoodEverydayControlle/AddHe_FoodRecipesEveryWeek`,
    params
  );
};
export const ResetUserPwd = (params) => {
  return axios.post(`${base}/api/back/UserManage/ResetUserPwd`, params);
};
export const GetHe_FoodTypeList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetHe_FoodTypeList`, {
      params: params,
    }
  );
};
export const GetHe_FoodMoonSummaryList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetHe_FoodMoonSummaryList`, {
      params: params,
    }
  );
};
export const GetEveryDayEveryOneFood = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetEveryDayEveryOneFood`, {
      params: params,
    }
  );
};
export const GetNutrientSource = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetNutrientSource`, {
      params: params,
    }
  );
};
export const GetFoodEvaluate = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetFoodEvaluate`, {
      params: params,
    }
  );
};
export const GetHe_FoodMoonPersonList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetHe_FoodMoonPersonList`, {
      params: params,
    }
  );
};
export const GetHe_FoodMoonRecipesList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetHe_FoodMoonRecipesList`, {
      params: params,
    }
  );
};
export const GetFoodReportInfo = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetFoodReportInfo`, {
      params: params,
    }
  );
};
export const GetFoodEveryDayEditList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodEverydayControlle/GetFoodEveryDayEditList`, {
      params: params,
    }
  );
};
export const GetPeopleDayPeport = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/GetPeopleDayPeport`, {
      params: params,
    }
  );
};
export const DelTeacherInfo = (params) => {
  return axios.post(`${base}/api/back/TeacherInfo/DelTeacherInfo`, params);
};
// 获取视频分类
export const AdminGetVideoCateList = (params) => {
  return axios.get(`${base}/api/mgd/Video/AdminGetVideoCateList`, {
    params,
  });
};

// 获取视频列表
export const AdminGetVideoByPage = (params) => {
  return axios.get(`${base}/api/mgd/Video/AdminGetVideoByPage`, {
    params,
  });
};

// ​/api​/mgd​/Video​/AdminGetOneInfo
// 获取视频详情
export const AdminGetOneInfo = (params) => {
  return axios.get(`${base}/api/mgd/Video/AdminGetOneInfo`, {
    params,
  });
};
// 新增视频
export const AdminAddVideoInfo = (params) => {
  return axios.post(`${base}/api/mgd/Video/AdminAddVideoInfo`, params);
};
// 修改视频
export const AdminUpdateVideoInfo = (params) => {
  return axios.post(`${base}/api/mgd/Video/AdminUpdateVideoInfo`, params);
};
// 视频批量上下架
export const AdminUpdatePubInfo = (params) => {
  return axios.post(`${base}/api/mgd/Video/AdminUpdatePubInfo`, params);
};
// 获取观看记录
export const AdminGetStudyRecordList = (params) => {
  return axios.get(`${base}/api/mgd/Video/AdminGetStudyRecordList`, {
    params,
  });
};
// 获取绘本列表
export const AdminGetStoryByPage = (params) => {
  return axios.get(`${base}/api/mgd/Story/AdminGetStoryByPage`, {
    params,
  });
};

// 获取绘本分类
export const FrontGetStoryTypeSelet = (params) => {
  return axios.get(`${base}/api/mgd/Story/FrontGetStoryTypeSelet`, {
    params,
  });
};

// 获取绘本类型
export const FrontGetStoryCategorySelet = (params) => {
  return axios.get(`${base}/api/mgd/Story/FrontGetStoryCategorySelet`, {
    params,
  });
};

// 添加、修改绘本
export const AdminAddUpdateStory = (params) => {
  return axios.post(`${base}/api/mgd/Story/AdminAddUpdateStory`, params);
};
// 获取绘本详情
export const AdminGetStoryOneInfo = (params) => {
  return axios.get(`${base}/api/mgd/Story/AdminGetStoryOneInfo`, {
    params,
  });
};

// 批量上下架绘本
export const AdminOpenCloseStory = (params) => {
  return axios.post(`${base}/api/mgd/Story/AdminOpenCloseStory`, params);
};

// 获取绘本子页
export const AdminGeStoryItemBytPage = (params) => {
  return axios.get(`${base}/api/mgd/Story/AdminGeStoryItemBytPage`, {
    params,
  });
};
// 添加绘本子页
export const AdminAddUpdateStoryItem = (params) => {
  return axios.post(`${base}/api/mgd/Story/AdminAddUpdateStoryItem`, params);
};

// /api/mgd/Story/AdminDeleteStoryItem
// 删除绘本子页
export const AdminDeleteStoryItem = (params) => {
  return axios.post(`${base}/api/mgd/Story/AdminDeleteStoryItem`, params);
};

// 获取故事题目
export const AdminGetStoryAfterQuestion = (params) => {
  return axios.get(`${base}/api/mgd/Story/AdminGetStoryAfterQuestion`, {
    params,
  });
};
// 添加故事题目
export const AdminAddUpdateStoryQuestion = (params) => {
  return axios.post(
    `${base}/api/mgd/Story/AdminAddUpdateStoryQuestion`,
    params
  );
};
// 删除故事题目
export const AdminDeleteStoryQuestion = (params) => {
  return axios.post(`${base}/api/mgd/Story/AdminDeleteStoryQuestion`, params);
};
export const GetReadArticleList = (params) => {
  return axios.get(
    `${base}/api/mgd/He_DiseasePreventionControlle/GetReadArticleList`, {
      params: params,
    }
  );
};

/**
 * 根据老师获取周期
 * @param {*} params
 * @returns
 */
export const GetCycleByTeacher = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/FrontGetCycleByTeacher`, {
    params: params,
  });
};

/**
 * 获取学期评价列表
 * @param {*} params
 * @returns
 */
export const FrontGetStudentListByTerm = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/FrontGetStudentListByTerm`, {
    params: params,
  });
};

export const GetStudentInfo = (params) => {
  return axios.get(`${base}/api/back/Student/GetStudentInfo`, {
    params: params,
  });
};

/**
 * 获取学期评价分类
 * @param {*} params
 * @returns
 */
export const AdminGetAllCategory = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/AdminGetAllCategory`, {
    params: params,
  });
};

/**
 * 学期评价统计柱状图
 * @param {*} params
 * @returns
 */
export const AdminGetTerm_HistogramByCycleClass = (params) => {
  return axios.get(
    `${base}/api/mgd/EvalTerm/AdminGetTerm_HistogramByCycleClass`, {
      params: params,
    }
  );
};

/**
 * 学期评价统计柱状图
 * @param {*} params
 * @returns
 */
export const AdminGetTerm_CompliancedataByCycleClass = (params) => {
  return axios.get(
    `${base}/api/mgd/EvalTerm/AdminGetTerm_CompliancedataByCycleClass`, {
      params: params,
    }
  );
};

//

/**
 * 学期评价统计柱状图
 * @param {*} params
 * @returns
 */
export const AdminGetTerm_HistogramByCycleGrade = (params) => {
  return axios.get(
    `${base}/api/mgd/EvalTerm/AdminGetTerm_HistogramByCycleGrade`, {
      params: params,
    }
  );
};

export const AdminGetProceListSan = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/AdminGetProceListSan`, {
    params: params,
  });
};

/**
 * 获取主题评价开关列表
 * @param {*} params
 * @returns
 */
export const AdminGetParentEvalByPage = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/AdminGetParentEvalByPage`, {
    params: params,
  });
};

/**
 * 家长评价开关
 * @param {*} params
 * @returns
 */
export const AdminUpdateParentEval = (params) => {
  return axios.post(`${base}/api/mgd/EvalTerm/AdminUpdateParentEval`, params);
};

//

/**
 * 获取学期评价学生列表
 * @param {*} params
 * @returns
 */
export const AdminGetTestStatusInfo = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/AdminGetTestStatusInfo`, {
    params,
  });
};

/**
 * 获取学期评价某个维度的佐证
 * @param {*} params
 * @returns
 */
export const AdminGetTearevalInfoByStudentCate = (params) => {
  return axios.get(
    `${base}/api/mgd/EvalTerm/AdminGetTearevalInfoByStudentCate`, {
      params,
    }
  );
};

/**
 * 保存佐证评价
 * @param {*} params
 * @returns
 */
export const AdminSaveTearevalInfoByStudentCate = (params) => {
  return axios.post(
    `${base}/api/mgd/EvalTerm/AdminSaveTearevalInfoByStudentCate`,
    params
  );
};

/**
 * 查询学期寄语
 * @param {*} params
 * @returns
 */
export const AdminGetTearMessageInfoByStudent = (params) => {
  return axios.get(
    `${base}/api/mgd/EvalTerm/AdminGetTearMessageInfoByStudent`, {
      params,
    }
  );
};

/**
 * 保存学期寄语
 * @param {*} params
 * @returns
 */
export const AdminSaveTearMessageInfoByStudent = (params) => {
  return axios.post(
    `${base}/api/mgd/EvalTerm/AdminSaveTearMessageInfoByStudent`,
    params
  );
};

/**
 * 获取学期评价题目
 * @param {*} params
 * @returns
 */
export const FrontGetQuestionByCategory = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/FrontGetQuestionByCategory`, {
    params,
  });
};

//
/**
 * 获取学期评价维度
 * @param {*} params
 * @returns
 */
export const FrontGetQuestionCategoryNodes = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/FrontGetQuestionCategoryNodes`, {
    params,
  });
};

/**
 * 批量保存学期评价
 * @param {*} params
 * @returns
 */
export const AdminSaveBatchTermInfo = (params) => {
  return axios.post(`${base}/api/mgd/EvalTerm/AdminSaveBatchTermInfo`, params);
};

/**
 * 获取过程评价列表
 * @param {*} params
 * @returns
 */
export const FrontGetProceListByPage = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/FrontGetProceListByPage`, {
    params,
  });
};

/**
 * 获取学生列表
 * @param {*} params
 * @returns  GET
 */
export const FrontGetStudentListByTermParent = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/FrontGetStudentListByTermParent`, {
    params,
  });
};

// FrontGetProceDetailInfo

/**
 * 获取过程评价列表
 * @param {*} params
 * @returns
 */
export const FrontGetProceDetailInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/FrontGetProceDetailInfo`, {
    params,
  });
};

/**
 * 获取过程评价详情
 * @param {*} params
 * @returns
 */
export const FrontGetProceDetailOneInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/FrontGetProceDetailOneInfo`, {
    params,
  });
};

/**
 * 保存过程评价维度
 * @param {*} params
 * @returns
 */
export const FrontSaveProceDetailOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Proce/FrontSaveProceDetailOneInfo`,
    params
  );
};

/**
 * 开启一个过程维度
 * @param {*} params
 * @returns
 */
export const FrontOpenProceDetailStatus = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Proce/FrontOpenProceDetailStatus`,
    params
  );
};
/**
 * 关闭一个过程维度
 * @param {*} params
 * @returns
 */
export const FrontCloseProceDetailStatus = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Proce/FrontCloseProceDetailStatus`,
    params
  );
};

/**
 * 获取过程报告详情
 * @param {*} params
 * @returns
 */
export const FrontAutoPdfInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/FrontAutoPdfInfo`, params);
};

/**
 * 删除过程报告
 * @param {*} params
 * @returns
 */
export const FrontDelProceInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/FrontDelProceInfo`, params);
};

/**
 * 新增过程报告
 * @param {*} params
 * @returns
 */
export const FrontAddProceInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/FrontAddProceInfo`, params);
};

/**
 * 获取表格2的名称
 * @param {*} params
 * @returns
 */
export const FrontGetTableTwoTitle = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/FrontGetTableTwoTitle`, {
    params,
  });
};

/**
 * 获取表格2的题目
 * @param {*} params
 * @returns
 */
export const FrontGetProceQuestionInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/FrontGetProceQuestionInfo`, {
    params,
  });
};

/**
 * 过程纬度开关列表 (Auth)
 * @param {*} params
 * @returns
 */
export const FrontGetProceList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/FrontGetProceList`, {
    params,
  });
};

/**
 * 批量创建过程评价
 * @param {*} params
 * @returns
 */
export const FrontCreateProceByClass = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Proce/FrontCreateProceByClass`,
    params
  );
};

/**
 * 获取学期评价报告
 * @param {*} params
 * @returns
 */
export const FrontTermReportDetailInfo = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/FrontTermReportDetailInfo`, {
    params,
  });
};

/**
 * pdf保存图片
 * @param {*} params
 * @returns
 */
export const MsaveImage = (params) => {
  return axios.post(`${base}/pdfapi/Pdf/MsaveImage`, params);
};

/**
 * 生成pdf
 * @param {*} params
 * @returns
 */
export const SetAutoPdfInfo = (params) => {
  return axios.post(`${base}/pdfapi/Pdf/AutoPdfInfo`, params);
};


/**
 * 生成pdf保存到本地
 * @param {*} params
 * @returns
 */
export const AutoPdfDownInfo = (params) => {
  return axios.post(`${base}/pdfapi/Pdf/AutoPdfDownInfo`, params);
};

/**
 * 下载压缩包
 * @param {*} params
 * @returns
 */
export const DownMyZip = (params) => {
  return axios.post(`${base}/pdfapi/Pdf/DownMyZip`, params);
};



/**
 *  查看家长评价
 * @param {*} params
 * @returns
 */
export const FrontParentAnswerReport = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/FrontParentAnswerReport`, {
    params,
  });
};

/**
 *  通过学生id获取云盘图片
 * @param {*} params
 * @returns
 */

export const GetSchoolStorage = (params) => {
  return axios.get(`${base}/api/Mu_CloudControlle/GetSchoolStorage`, {
    params,
  });
};
export const GetClassByCustomerId = (params) => {
  return axios.get(`${base}/api/MuGrowthRecord/GetClassByCustomerId`, {
    params,
  });
};
export const GetCloudCustomerList = (params) => {
  return axios.get(`${base}/api/Mu_CloudControlle/GetCloudCustomerList`, {
    params,
  });
};
export const AddCloudFile = (params) => {
  return axios.post(`${base}/api/Mu_CloudControlle/AddCloudFile`, params);
};
export const UploadFile = (params) => {
  return axios.post(`${base}/api/Img/UploadFile`, params);
};
export const GetCloudFileByFolderId = (params) => {
  return axios.get(`${base}/api/Mu_CloudControlle/GetCloudFileByFolderId`, {
    params,
  });
};
export const DeleteCloudFile = (params) => {
  return axios.post(`${base}/api/Mu_CloudControlle/DeleteCloudFile`, params);
};
export const UpdateCloudFileType = (params) => {
  return axios.post(
    `${base}/api/Mu_CloudControlle/UpdateCloudFileType`,
    params
  );
};
export const AddCloudFileType = (params) => {
  return axios.post(`${base}/api/Mu_CloudControlle/AddCloudFileType`, params);
};
export const GetCloudFileType = (params) => {
  return axios.get(`${base}/api/Mu_CloudControlle/GetCloudFileType`, {
    params,
  });
};
export const DeleteCloudFileType = (params) => {
  return axios.post(
    `${base}/api/Mu_CloudControlle/DeleteCloudFileType`,
    params
  );
};
export const UpdateCloudFileTypeName = (params) => {
  return axios.post(
    `${base}/api/Mu_CloudControlle/UpdateCloudFileTypeName`,
    params
  );
};

/**
 *  获取主题评价列表
 * @param {*} params
 * @returns
 */
export const GetEval_ThemeByPage = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetEval_ThemeByPage`, {
    params,
  });
};

/**
 *  获取年级范围接口
 * @param {*} params
 * @returns
 */
export const GetThemeRange = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetThemeRange`, {
    params,
  });
};
/**
 * 创建主题评价
 * @param {*} params
 * @returns
 */
export const AddEval_ThemeInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Theme/AdminAddEval_ThemeInfo`,
    params
  );
};
/**
 * 修改主题评价
 * @param {*} params
 * @returns
 */
export const UpdateEval_ThemeInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Theme/AdminUpdateEval_ThemeInfo`,
    params
  );
};
/**
 * 修改主题封面
 * @param {*} params
 * @returns
 */
export const UpdateEval_ThemeImgInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Theme/AdminUpdateEval_ThemeImgInfo`,
    params
  );
};

/**
 * 删除主题评价
 * @param {*} params
 * @returns
 */
export const DeleteThemeInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Theme/AdminDeleteThemeInfo`, params);
};

/**
 * 开启或关闭主题评价
 * @param {*} params
 * @returns
 */
export const OpenCloseEval_ThemeInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Theme/AdminOpenCloseEval_ThemeInfo`,
    params
  );
};

/**
 *  获取主题详情
 * @param {*} params
 * @returns
 */
export const GetEditEval_ThemeInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetEditEval_ThemeInfo`, {
    params,
  });
};

/**
 *  获取主题评价题目列表
 * @param {*} params
 * @returns
 */
export const GetEval_ThemeQuestionList = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Theme/AdminGetEval_ThemeQuestionList`, {
      params,
    }
  );
};
/**
 * 添加主题评价问题
 * @param {*} params
 * @returns
 */
export const AddEval_ThemeQuestionInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Theme/AdminAddEval_ThemeQuestionInfo`,
    params
  );
};

/**
 *  获取主题评价关键词
 * @param {*} params
 * @returns
 */
export const GetKeyWords = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetKeyWords`, {
    params,
  });
};
export const AdminGetThemeDesc = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetThemeDesc`, {
    params,
  });
};
/**
 * 导入主题评价题目
 * @param {*} params
 * @returns
 */
export const ImportEval_ThemeQuestionInfo = (params) => {
  return axios.post(
    `${base}/import/ImportInfo/AdminImportEval_ThemeQuestionInfo`,
    params
  );
};

/**
 * 删除主题评价题目
 * @param {*} params
 * @returns
 */
export const DeleteThemeQuestionInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Theme/AdminDeleteThemeQuestionInfo`,
    params
  );
};
/**
 *  获取主题评价班级报告
 * @param {*} params
 * @returns
 */
export const GetEval_ThemeClassByPage = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetEval_ThemeClassByPage`, {
    params,
  });
};
/**
 *  获取获取主题评价学生报告
 * @param {*} params
 * @returns
 */
export const GetEval_ThemeStudentByPage = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Theme/AdminGetEval_ThemeStudentByPage`, {
      params,
    }
  );
};

/**
 *  获取获取主题评价列表
 * @param {*} params
 * @returns
 */
export const GetThemeSelect = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetThemeSelect`, {
    params,
  });
};

/**
 *  获取获取主题详情
 * @param {*} params
 * @returns
 */
export const GetBabyEval_ThemeDetail = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/FronGetBabyEval_ThemeDetail`, {
    params,
  });
};
/**
 *  保存主题评价
 * @param {*} params
 * @returns
 */
export const SaveBabyEval_ThemeDetail = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Theme/FronSaveBabyEval_ThemeDetail`,
    params
  );
};

/**
 *  批量保存主题评价
 * @param {*} params
 * @returns
 */
export const SaveCacheThemeInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Theme/AdminSaveCacheThemeInfo`,
    params
  );
};
//
/**
 *  根据主题id获取封面封底
 * @param {*} params
 * @returns
 */
export const GetCoverImgByThemeId = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetCoverImgByThemeId`, {
    params,
  });
};

/**
 *  获取主题评价班级报告
 * @param {*} params
 * @returns
 */
export const GetClassReportInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetClassReportInfo`, {
    params,
  });
};

// 成长足迹
/**
 * 新增成长足迹
 * @param {*} params
 * @returns
 */
export const CreateTenantTempInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Growth/CreateTenantTempInfo`, params);
};

/**
 * 获成长足迹
 * @param {*} params
 * @returns
 */
export const GetTenantTempByPage = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetTenantTempByPage`, {
    params,
  });
};

/**
 * 修改成长足迹
 * @param {*} params
 * @returns
 */
export const UpdateTenantTempOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/UpdateTenantTempOneInfo`,
    params
  );
};

/**
 * 根据id获取成长足迹信息
 * @param {*} params
 * @returns
 */
export const GetTenantTempOneInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetTenantTempOneInfo`, {
    params,
  });
};
/**
 * 开启或关闭成长足迹
 * @param {*} params
 * @returns
 */
export const OpenCloseTenantTempOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/OpenCloseTenantTempOneInfo`,
    params
  );
};

/**
 * 删除成长足迹
 * @param {*} params
 * @returns
 */
export const DeleteTenantTempOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/DeleteTenantTempOneInfo`,
    params
  );
};

/**
 * 获取成长记录操作人列表
 * @param {*} params
 * @returns
 */
export const GetTenantTempOperatorInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetTenantTempOperatorInfo`, {
    params,
  });
};

/**
 * 获取模块列表
 * @param {*} params
 * @returns
 */
export const GetTenantTempTypeInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetTenantTempTypeInfo`, {
    params,
  });
};

/**
 * 添加成长记录子模块
 * @param {*} params
 * @returns
 */
export const AddTenantTempDetailOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/AddTenantTempDetailOneInfo`,
    params
  );
};

/**
 * 获取成长记录子模块列表
 * @param {*} params
 * @returns
 */
export const GetTenantTempDetailInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetTenantTempDetailInfoWeb`, {
    params,
  });
};


export const GetTempDetailList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetTempDetailList`, {
    params,
  });
};


/**
 * 删除成长记录子模块
 * @param {*} params
 * @returns
 */
export const DeleteTenantTempDetailOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/DeleteTenantTempDetailOneInfo`,
    params
  );
};

export const getclassAll = (params) => {
  // getAcademicSelect //学界下拉
  // GetCycleSelectList 获取周期
  // GetClassList 获取班级列表
};

/**
 * 成长足迹获取范围
 * @param {*} params
 * @returns
 */
export const GetTenantTempRange = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetTenantTempRange`, {
    params,
  });
};

/**
 * 开启关闭成长足迹子模块
 * @param {*} params
 * @returns
 */
export const OpenCloseTenantTempDetailOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/OpenCloseTenantTempDetailOneInfo`,
    params
  );
};

/**
 * 修改成长足迹子模块
 * @param {*} params
 * @returns
 */
export const UpdateTenantTempDetailOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/UpdateTenantTempDetailOneInfo`,
    params
  );
};

/**
 * 成长记录表 配置除记录表以外的其他模块
 * @param {*} params
 * @returns
 */
export const SaveTenantTempDetailOneInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/SaveTenantTempDetailOneInfo`,
    params
  );
};

/**
 * 获取成长组件背景列表
 */
export const GetBackCoverImgList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetBackCoverImgList`, {
    params,
  });
};
/**
 * 获取成长足迹板式列表
 * @param {*} params
 * @returns
 */
export const GetPlateList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetPlateList`, {
    params,
  });
};

/**
 * 批量导入记录表
 */
export const ImportTenantTempDetailOneInfoByCycleWrite = (params) => {
  return axios.post(
    `${base}/import/ImportInfo/ImportTenantTempDetailOneInfoByCycleWrite`,
    params
  );
};

/**
 * 修改成长足迹观察点
 * @param {*} params
 * @returns
 */
export const UpdateTenantTempDetailOneInfoByCycleWrite = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/UpdateTenantTempDetailOneInfoByCycleWrite`,
    params
  );
};
/**
 * 删除成长足迹观察点
 * @param {*} params
 * @returns
 */
export const DeleteGrowTempQuestion = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/DeleteGrowTempQuestion`,
    params
  );
};

/**
 * 获取成长足迹子模块详情(记录表)
 * @param {*} params
 * @returns
 */
export const GetTenantTempDetailOneInfoByCycleWrite = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Growth/GetTenantTempDetailOneInfoByCycleWrite`, {
      params,
    }
  );
};
//

/**
 * 获取成长足迹子模块详情(除记录表以外的)
 * @param {*} params
 * @returns
 */
export const GetTenantTempDetailOneInfoByImgTextRecord = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Growth/GetTenantTempDetailOneInfoByImgTextRecord`, {
      params,
    }
  );
};

/**
 * 获取成长足迹目录
 * @param {*} params
 * @returns
 */
export const GetTenantTempDetailCatalogueInfo = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Growth/GetTenantTempDetailCatalogueInfo`, {
      params,
    }
  );
};

/**
 * 成长足迹恢复默认
 * @param {*} params
 * @returns
 */
export const ResetTempInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Growth/ResetTempInfo`, params);
};

/**
 * 获取报告列表
 * @param {*} params
 * @returns
 */
export const WebGrowStudentList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/WebGrowStudentList`, {
    params,
  });
};

/**
 * 获取记录界面列表
 * @param {*} params
 * @returns
 */
export const WriteTempDetailList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/WriteTempDetailList`, {
    params,
  });
};

/**
 * 获取记录界面 子模块信息
 * @param {*} params
 * @returns
 */
export const GoTenantTempDetailOneInfoByImgTextRecord = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Growth/GoTenantTempDetailOneInfoByImgTextRecord`, {
      params,
    }
  );
};

//
/**
 * 保存成长足迹
 * @param {*} params
 * @returns
 */
export const SaveDetailInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Growth/SaveDetailInfo`, params);
};

//
/**
 * 获取记录界面 子模块信息(记录表 过程)
 * @param {*} params
 * @returns
 */
export const GoTenantTempDetailOneInfoByCycleWrite = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Growth/GoTenantTempDetailOneInfoByCycleWrite`, {
      params,
    }
  );
};

/**
 * 获取记录界面 子模块信息(记录表 学期)
 * @param {*} params
 * @returns
 */
export const GoTenantTempDetailOneInfoByCycleWriteCycle = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Growth/GoTenantTempDetailOneInfoByCycleWriteCycle`, {
      params,
    }
  );
};

/**
 *
 */

/**
 * 成长足迹拖动排序
 * @param {*} params
 * @returns
 */
export const SortGrowDetailInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Growth/SortGrowDetailInfo`, params);
};

/**
 * 为某个孩子添加一个子模块
 * @param {*} params
 * @returns
 */
export const AddGrowDetailOneList = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Growth/AddGrowDetailOneList`, params);
};

/**
 * 批量记录
 * @param {*} params
 * @returns
 */
export const SaveBatchDetailInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Growth/SaveBatchDetailInfo`, params);
};

/**
 * 成长足迹 过程记录自动生成
 * @param {*} params
 * @returns
 */
export const AutoCustomerContent = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Growth/AutoCustomerContent`, params);
};

/**
 * 成长足迹 获取结语模板列表
 * @param {*} params
 * @returns
 */
export const GetEpilogueList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetEpilogueList`, {
    params,
  });
};

// 成长足迹报告
export const StudentGrowReportInfo = (data) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/StudentGrowReportInfo`, {
    params: data,
  });
};

// 批量开启
export const BatchOpenCloseTenantTempDetail = (data) => {
  return axios.post(
    `${base}/api/mgd/Eval_Growth/BatchOpenCloseTenantTempDetail`,
    data
  );
};
//通过范围获取周期
export const GetCycleSelectListByScope = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetCycleInfoByRange`, {
    params,
  });
};

/**
 * 常用语管理列表
 * @param {*} params
 * @returns
 */
export const FrontGetMessageTemplateList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/FrontGetMessageTemplateList`, {
    params,
  });
};
/**
 * 常用语管理列表
 * @param {*} params
 * @returns
 */
export const FrontSchoolTempRecommend = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/FrontSchoolTempRecommend`, {
    params,
  });
};

/**
 * 删除常用语
 */
export const FrontDeleteMessageTemplate = (data) => {
  return axios.post(
    `${base}/api/mgd/Eval_Proce/FrontDeleteMessageTemplate`,
    data
  );
};

/**
 * 添加常用语
 */
export const FrontAddMessageTemplate = (data) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/FrontAddMessageTemplate`, data);
};

/**
 *
 */
export const GetEditQuestion = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/WebGetEditQuestion`, {
    params,
  });
};
/**
 *获取表格2名称
 */
export const GetTableTwoTitle = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/WebGetTableTwoTitle`, {
    params,
  });
};

/**
 * 保存表格2名称
 * @param {*} data
 * @returns
 */
export const SaveTableTwoTitle = (data) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/WebSaveTableTwoTitle`, data);
};

/*
 *获取表格2名称分页 获取学校问题列表 需要排序 ordersort 增加了 年级筛选=范围名称筛选 GradeName (Auth)
 */
export const GetProceQuestionByPage = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/WebGetProceQuestionByPage`, {
    params,
  });
};

/**
 * 添加表格2问题
 * @param {*} data
 * @returns
 */
export const AddProceQuestion = (data) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/WebAddProceQuestion`, data);
};

/**
 * 修改表格2问题
 * @param {*} data
 * @returns
 */
export const UpdateProceQuestion = (data) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/WebUpdateProceQuestion`, data);
};

/**
 * 修改表格2问题
 * @param {*} data
 * @returns
 */
export const DeleteProceQuestion = (data) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/WebDeleteProceQuestion`, data);
};

/**
 * 批量导入表格2问题
 * @param {*} data
 * @returns
 */
export const ImportProceQuestion = (data) => {
  return axios.post(`${base}/import/ImportInfo/WebImportProceQuestion`, data);
};

/**
 * 获取表格1问题
 * @param {*} data
 * @returns
 */
export const GetProcessEvaluationTable = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/WebGetProcessEvaluationTable`, {
    params,
  });
};

/**
 * 获取表格1问题
 * @param {*} data
 * @returns
 */
export const AddProcessEvaluationTable = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Proce/WebAddProcessEvaluationTable`,
    params
  );
};

/**
 * 删除表格1
 * @param {*} data
 * @returns
 */
export const DeleteProcessEvaluationTable = (params) => {
  return axios.post(
    `${base}/api/mgd/Eval_Proce/WebDeleteProcessEvaluationTable`,
    params
  );
};

/**
 * 获取表格1详情
 * @param {*} data
 * @returns
 */
export const GetProcessEvaluationTableSigin = (params) => {
  return axios.get(
    `${base}/api/mgd/Eval_Proce/WebGetProcessEvaluationTableSigin`, {
      params,
    }
  );
};

/**
 * 添加园本特色
 * @param {*} params
 * @returns
 */
export const AddMyQuestionCategoryInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/EvalTerm/WebAddMyQuestionCategoryInfo`,
    params
  );
};

/**
 * 获取学期评价自定义维度
 * @param {*} data
 * @returns
 */
export const GetMyQuestionCategoryList = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/WebGetMyQuestionCategoryList`, {
    params,
  });
};

/**
 * 删除自定义维度
 * @param {*} data
 * @returns
 */
export const WebDeleteMyQuestionCategory = (params) => {
  //return axios.post(`${base}/api/mgd/EvalTerm/WebImportMyQuestionCategoryInfo`, params);
  return axios.post(
    `${base} /api/mgd/EvalTerm/WebDeleteMyQuestionCategory`,
    params
  );
};
/**
 * 根据纬度导入试题
 * @param {*} params
 * @returns
 */
export const ImportMyQuestionCategoryInfo = (params) => {
  //return axios.post(`${base}/api/mgd/EvalTerm/WebImportMyQuestionCategoryInfo`, params);
  return axios.post(
    `${base} /import/ImportInfo/WebImportMyQuestionCategoryInfo`,
    params
  );
};

/**
 * 获取纬度试题列表 Id为纬度Id (Auth)
 * @param {*} data
 * @returns
 */
export const GetMyQuestionList = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/WebGetMyQuestionList`, {
    params,
  });
};

/**
 * 根据纬度导入试题
 * @param {*} params
 * @returns
 */
export const IsOpenQuestionType = (params) => {
  return axios.post(`${base}/api/mgd/EvalTerm/WebIsOpenQuestionType`, params);
};

export const GetCycleInfoByRange = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetCycleInfoByRange`, {
    params,
  });
};
export const GetTenantTypeEnum = (params) => {
  return axios.get(`${base}/api/back/School/GetTenantTypeEnum`, {
    params,
  });
};
export const GetNatureEnum = (params) => {
  return axios.get(`${base}/api/back/School/GetNatureEnum`, {
    params,
  });
};
export const GetKindergartenLevel = (params) => {
  return axios.get(`${base}/api/back/School/GetKindergartenLevel`, {
    params,
  });
};
export const DeleteUserByIds = (params) => {
  return axios.post(`${base}/api/back/UserManage/DeleteUserByIds`, params);
};
export const GetUserIdentityNameType = (params) => {
  return axios.get(`${base}/api/Role/GetUserIdentityNameType`, {
    params: params,
  });
};
export const GetVersionList = (params) => {
  return axios.get(`${base}/api/SystemVersion/GetVersionList`, {
    params,
  });
};
export const GetVersionEdit = (params) => {
  return axios.post(`${base}/api/SystemVersion/GetVersionEdit`, params);
};
export const GetVersionDel = (params) => {
  return axios.post(`${base}/api/SystemVersion/GetVersionDel`, params);
};
export const SaveThemeDesc = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Theme/AdminSaveThemeDesc`, params);
};
export const GetThemeDesc = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/AdminGetThemeDesc`, {
    params,
  });
};
export const GetReportListByPage = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/GetReportListByPage`, {
    params,
  });
};
export const GetVersionAdd = (params) => {
  return axios.post(`${base}/api/SystemVersion/GetVersionAdd`, params);
};
export const AddBatchMessage = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/AddBatchMessage`, params);
};
export const GetTeacherAttendStatis = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetTeacherAttendStatis`, {
    params,
  });
};
export const GetWebStudentAttendStatis = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetWebStudentAttendStatis`, {
    params,
  });
};
export const GetTeacherClassRoleInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/GetTeacherClassRoleInfo`, {
    params,
  });
};
export const GetSchoolBaseInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetSchoolBaseInfo`, {
    params,
  });
};
export const GetSchoolScienceInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetSchoolScienceInfo`, {
    params,
  });
};
export const GetSchoolCloudDiskInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetSchoolCloudDiskInfo`, {
    params,
  });
};
export const GetSchoolDietaryInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetSchoolDietaryInfo`, {
    params,
  });
};
export const GetOpenCycleInfoSelectResult = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetOpenCycleInfoSelectResult`, {
    params,
  });
};
export const GetSchoolHealthyInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetSchoolHealthyInfo`, {
    params,
  });
};
export const GetStudentInfoByClassId = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetStudentInfoByClassId`, {
    params,
  });
};
export const GetSchoolEvalInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetSchoolEvalInfo`, {
    params,
  });
};
export const GetGrowthQuestionDetail = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetGrowthQuestionDetail`, {
    params,
  });
};
export const GetGrowthQuestion = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetGrowthQuestion`, {
    params,
  });
};

export const ImportGrowthQuestion = (params) => {
  return axios.post(`${base}/import/ImportInfo/ImportGrowthQuestion`, params);
};
export const Export_GetEveryDayEveryOneFood = (params) => {
  return axios.get(
    `${base}/api/mgd/He_FoodReportTableControlle/Export_GetEveryDayEveryOneFood`, {
      params,
    }
  );
};
export const GetHealthInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetHealthInfo`, {
    params,
  });
};
export const GetTaskInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetTaskInfo`, {
    params,
  });
};
export const GetSchoolDietaryIndexInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetSchoolDietaryIndexInfo`, {
    params,
  });
};
export const GetSchoolDiseasePreventionIndexInfo = (params) => {
  return axios.get(
    `${base}/api/mgd/SchoolBase/GetSchoolDiseasePreventionIndexInfo`, {
      params,
    }
  );
};
export const GetIndex_Home_MessageInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetIndex_Home_MessageInfo`, {
    params,
  });
};
export const GetIndex_Home_ClassCircleInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetIndex_Home_ClassCircleInfo`, {
    params,
  });
};
export const GetIndex_Home_SecurityInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetIndex_Home_SecurityInfo`, {
    params,
  });
};
export const GetTeacherBookInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetTeacherBookInfo`, {
    params,
  });
};
export const GetTeacherTestInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetTeacherTestInfo`, {
    params,
  });
};
export const GetStudentGrowInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetStudentGrowInfo`, {
    params,
  });
};
export const GetParentGrowInfo = (params) => {
  return axios.get(`${base}/api/mgd/SchoolBase/GetParentGrowInfo`, {
    params,
  });
};
export const GetIsTestInfo = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/GetIsTestInfo`, {
    params,
  });
};
export const GetParentTestStatusInfo = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/GetParentTestStatusInfo`, {
    params,
  });
};
export const GetParentIsTestInfo = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/GetParentIsTestInfo`, {
    params,
  });
};
export const GetEval_ThemeIsTestByPage = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Theme/GetEval_ThemeIsTestByPage`, {
    params,
  });
};

export const GetIndex_ProceInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/GetIndex_ProceInfo`, {
    params,
  });
};
export const WebGrowIsTestList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/WebGrowIsTestList`, {
    params,
  });
};
export const Export_AdminGetTestStatusInfo = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/Export_AdminGetTestStatusInfo`, {
    params,
  });
};
export const GetBookCateOneInfo = (params) => {
  return axios.get(`${base}/api/mgd/Book/GetBookCateOneInfo`, {
    params,
  });
};
export const GetBookCateTwoThreeInfo = (params) => {
  return axios.get(`${base}/api/mgd/Book/GetBookCateTwoThreeInfo`, {
    params,
  });
};
export const GetBookInfoByPage = (params) => {
  return axios.get(`${base}/api/mgd/Book/GetBookInfoByPage`, {
    params,
  });
};
export const AddBookFileInfo = (params) => {
  return axios.post(`${base}/api/mgd/Book/AddBookFileInfo`, params);
};
export const DeleteBookFileInfo = (params) => {
  return axios.post(`${base}/api/mgd/Book/DeleteBookFileInfo`, params);
};
export const GetAdminCateInfo = (params) => {
  return axios.get(`${base}/api/mgd/Cs_Question/GetAdminCateInfo`, {
    params,
  });
};
export const GetCS_CateByPage = (params) => {
  return axios.get(`${base}/api/mgd/Cs_Question/GetCS_CateByPage`, {
    params,
  });
};
export const AddCs_Question = (params) => {
  return axios.post(`${base}/api/mgd/Cs_Question/AddCs_Question`, params);
};
export const DeleteCs_QuestionInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Cs_Question/DeleteCs_QuestionInfo`,
    params
  );
};
export const UpdateAddCs_Question = (params) => {
  return axios.post(`${base}/api/mgd/Cs_Question/UpdateAddCs_Question`, params);
};
export const OpenCloseCs_QuestionInfo = (params) => {
  return axios.post(
    `${base}/api/mgd/Cs_Question/OpenCloseCs_QuestionInfo`,
    params
  );
};

export const Cs_QuestionImportMyQuestionCategoryInfo = (params) => {
  return axios.post(
    `${base}/import/ImportInfo/ImportMyQuestionCategoryInfo`,
    params
  );
};
export const GetStudentPhysicalInfo = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetStudentPhysicalInfo`, {
    params,
  });
};
export const GetWxMainInfoByPage = (params) => {
  return axios.get(`${base}/api/mgd/WxMain/GetWxMainInfoByPage`, {
    params,
  });
};
export const AddWxMainInfo = (params) => {
  return axios.post(`${base}/api/mgd/WxMain/AddWxMainInfo`, params);
};
export const DeleteWxMainInfo = (params) => {
  return axios.post(`${base}/api/mgd/WxMain/DeleteWxMainInfo`, params);
};
export const GetWxDetailInfoByPage = (params) => {
  return axios.get(`${base}/api/mgd/WxMain/GetWxDetailInfoByPage`, {
    params,
  });
};
export const AddWxDetailInfo = (params) => {
  return axios.post(`${base}/api/mgd/WxMain/AddWxDetailInfo`, params);
};
export const UploadMultimedia = (params) => {
  return axios.post(`${base}/api/mgd/WxMain/UploadMultimedia`, params);
};
export const DeleteWxDetailInfo = (params) => {
  return axios.post(`${base}/api/mgd/WxMain/DeleteWxDetailInfo`, params);
};
export const DeleteStudentInfo = (params) => {
  return axios.post(`${base}/api/back/Student/DeleteStudentInfo`, params);
};
export const GetWxMenu = (params) => {
  return axios.get(`${base}/api/mgd/WxMain/GetWxMenu`, {
    params,
  });
};
export const SaveWxMenu = (params) => {
  return axios.post(`${base}/api/mgd/WxMain/SaveWxMenu`, params);
};
export const AutoSchoolRoleInfo = (params) => {
  return axios.post(`${base}/api/Role/AutoSchoolRoleInfo`, params);
};
export const GetTableByGrowDetail = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Growth/GetTableByGrowDetail`, {
    params,
  });
};
export const Get_Hx_MyToolInfo = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetNewModel_Hx_MyToolInfo`, {
    params,
  });
};
export const AddUpdate_Hx_MyToolInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/AddUpdate_Hx_MyToolInfo`, params);
};
export const Delete_Hx_MyToolInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/Delete_Hx_MyToolInfo`, params);
};

export const GetHx_CloudInfo = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetHx_CloudInfo`, {
    params,
  });
};

export const CreateHx_Cloud_FolderInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/CreateHx_Cloud_FolderInfo`, params);
};
export const UpdateHx_Cloud_FolderInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/UpdateHx_Cloud_FolderInfo`, params);
};

export const DeleteHx_Cloud_FolderInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/DeleteHx_Cloud_FolderInfo`, params);
};

export const GetHx_CloudFileInfo = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetHx_CloudFileInfo`, {
    params,
  });
};

export const UploadFileNewCloud = (params) => {
  return axios.post(`${base}/api/Img/UploadFileNewCloud`, params);
};

export const AddHx_Cloud_FileInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/AddHx_Cloud_FileInfo`, params);
};

export const UpdateHx_Cloud_FileInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/UpdateHx_Cloud_FileInfo`, params);
};

export const DeleteHx_Cloud_FileInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/DeleteHx_Cloud_FileInfo`, params);
};

export const AddShareInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/AddShareInfo`, params);
};
export const GetSourceTypeList = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetSourceTypeList`, {
    params,
  });
};
export const GetSourceInfoByPage = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetSourceInfoByPage`, {
    params,
  });
};
export const GetSourceDetail = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetSourceDetail`, {
    params,
  });
};
export const MakeHx_SourceInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/MakeHx_SourceInfo`, params);
};
export const CancelMakeHx_Source = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/CancelMakeHx_Source`, params);
};
export const AddSourceFavorite = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/AddSourceFavorite`, params);
};
export const ManageGetHx_SourceByPage = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/ManageGetHx_SourceByPage`, {
    params,
  });
};
export const ManageAddHx_SourceInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/ManageAddHx_SourceInfo`, params);
};
export const GetMakeDetailBySource = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetMakeDetailBySource`, {
    params,
  });
};
export const ManageDeleteHx_SourceInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/ManageDeleteHx_SourceInfo`, params);
};
export const ManageGetHx_SourceDetail = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/ManageGetHx_SourceDetail`, {
    params,
  });
};
export const GetAllShareInfo = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetAllShareInfo`, {
    params,
  });
};
export const GetFavoriteBySource = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetFavoriteBySource`, {
    params,
  });
};
export const CheckSourceInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/CheckSourceInfo`, params);
};
export const AutoSchoolLevel = (params) => {
  return axios.post(`${base}/api/back/School/AutoSchoolLevel`, params);
};
export const GetMyMakeDetail = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetMyMakeDetail`, {
    params,
  });
};
export const GetCloudFilePageingByFolderId = (params) => {
  return axios.get(`${base}/api/Mu_CloudControlle/GetCloudFilePageingByFolderId`, {
    params,
  });
};
export const ImportUpdateTeacherRole = (params) => {
  return axios.post(`${base}/import/ImportInfo/ImportUpdateTeacherRole`, params);
};
export const GetGradeSelectByRole = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetGradeSelectByRole`, {
    params,
  });
};


export const GetMSGradeInfo = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetMSGradeInfo`, {
    params,
  });
};
export const GetMSClassInfo = (params) => {
  return axios.get(`${base}/api/back/SchoolInfo/GetMSClassInfo`, {
    params,
  });
};

export const BatchAddHx_Cloud_FileInfo = (params) => {
  return axios.post(`${base}/api/mgd/Hx_Source/BatchAddHx_Cloud_FileInfo`, params);
};
export const UploadFilesPag = (params) => {
  return axios.post(`${base}/api/OtherFile/UploadFilesPag`, params);
};
//绑定手环
export const StuBindMacInfo = (params) => {
  return axios.post(`${base}/api/mgd/SportManege/StuBindMacInfo`, params);
};
//获取班级网关Mac
export const GetClassMacInfo = (params) => {
  return axios.get(`${base}/api/mgd/SportManege/GetClassMacInfo`, {
    params,
  });
};
export const GetTempFoodRecipesInfo = (params) => {
  return axios.get(`${base}/api/Food/GetTempFoodRecipesInfo`, {
    params,
  });
};
export const CheckWeekReciperInfo = (params) => {
  return axios.post(`${base}/api/Food/CheckWeekReciperInfo`, params);
};
export const GetWeekReciperInfo = (params) => {
  return axios.get(`${base}/api/Food/GetWeekReciperInfo`, {
    params,
  });
};
export const DeleteWeekReciperInfo = (params) => {
  return axios.post(`${base}/api/Food/DeleteWeekReciperInfo`, params);
};
export const GetFoodDish = (params) => {
  return axios.get(`${base}/api/Food/GetFoodDish`, {
    params,
  });
};
export const GetFoodLibrary = (params) => {
  return axios.get(`${base}/api/Food/GetFoodLibrary`, {
    params,
  });
};
export const AddWeekReciperInfo = (params) => {
  return axios.post(`${base}/api/Food/AddWeekReciperInfo`, params);
};
export const UpdateWeekReciperInfo = (params) => {
  return axios.post(`${base}/api/Food/UpdateWeekReciperInfo`, params);
};
export const GetFoodTypeInfo = (params) => {
  return axios.get(`${base}/api/Food/GetFoodTypeInfo`, {
    params,
  });
};
export const AddFoodLibary = (params) => {
  return axios.post(`${base}/api/Food/AddFoodLibary`, params);
};
export const UpdateFoodLibary = (params) => {
  return axios.post(`${base}/api/Food/UpdateFoodLibary`, params);
};
export const DeleteFoodLibary = (params) => {
  return axios.post(`${base}/api/Food/DeleteFoodLibary`, params);
};
export const GetMonthReportInfo = (params) => {
  return axios.get(`${base}/api/Food/GetMonthReportInfo`, {
    params,
  });
};
export const GetEscalationEstimatePeopleList = (params) => {
  return axios.get(`${base}/api/Food/GetEscalationEstimatePeopleList`, {
    params,
  });
};
export const EscalationEstimatePeople = (params) => {
  return axios.post(`${base}/api/Food/EscalationEstimatePeople`, params);
};
export const GetBabyLevelInfo = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/GetBabyLevelInfo`, {
    params,
  });
};
export const ImportMyQuestionCategoryByZeroInfo = (params) => {
  return axios.post(`${base}/import/ImportInfo/ImportMyQuestionCategoryByZeroInfo`, params);
};
export const GetMyQuestionListByZero = (params) => {
  return axios.get(`${base}/api/mgd/EvalTerm/GetMyQuestionListByZero`, {
    params,
  });
};
export const AutoProceCustomInfo = (params) => {
  return axios.post(`${base}/api/mgd/Eval_Proce/AutoProceCustomInfo`, params);
};
export const Export_GetHe_FoodEverydayDetailList = (params) => {
  return axios.get(`${base}/api/mgd/He_FoodEverydayControlle/Export_GetHe_FoodEverydayDetailList`, {
    params,
  });
};
export const GetFoodMonth = (params) => {
  return axios.get(`${base}/api/Food/GetFoodMonth`, {
    params,
  });
};
export const GetProceTitleList = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/GetProceTitleList`, {
    params,
  });
};
export const GetStudentListByProceDown = (params) => {
  return axios.get(`${base}/api/mgd/Eval_Proce/GetStudentListByProceDown`, {
    params,
  });
};
export const GetTempFoodHorizontalRecipesInfo = (params) => {
  return axios.get(`${base}/api/Food/GetTempFoodHorizontalRecipesInfo`, {
    params,
  });
};
export const GetWeekHorizontalReciperInfo = (params) => {
  return axios.get(`${base}/api/Food/GetWeekHorizontalReciperInfo`, {
    params,
  });
};
export const GetBookkeepingdietInfo = (params) => {
  return axios.get(`${base}/api/Food/GetBookkeepingdietInfo`, {
    params,
  });
};
export const SourceNameCheck = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/SourceNameCheck`, {
    params,
  });
};
export const GetMyRecordInfoByPage = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetMyRecordInfoByPage`, {
    params,
  });
};
export const GetRecordInfoByPage = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetRecordInfoByPage`, {
    params,
  });
};
export const GetRecordDownImgList = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetRecordDownImgList`, {
    params,
  });
};
export const SportStudentList = (params) => {
  return axios.get(`${base}/sp/mgd/Sport/SportStudentList`, {
    params,
  });
};
export const GetSportDateDedailByData = (params) => {
  return axios.get(`${base}/sp/mgd/Sport/GetSportDateDedailByData`, {
    params,
  });
};
export const GetSportDateByData = (params) => {
  return axios.get(`${base}/sp/mgd/Sport/GetSportDateByData`, {
    params,
  });
};
export const GetTeacherStudyInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetTeacherStudyInfo`, {
    params,
  });
};
export const GetCateInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetCateInfo`, {
    params,
  });
};
export const GetSecVideoInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetSecVideoInfo`, {
    params,
  });
};
export const GetVideoDetailList = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetVideoDetailList`, {
    params,
  });
};
export const AddVideoNoteInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/AddVideoNoteInfo`, params);
};
export const GetSelectByVideoList = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetSelectByVideoList`, {
    params,
  });
};
export const GetOverCateInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetOverCateInfo`, {
    params,
  });
};
export const GetCertificateInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetCertificateInfo`, {
    params,
  });
};
export const GetTodayStudyRecordInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetTodayStudyRecordInfo`, {
    params,
  });
};
export const GetOldStudyRecordInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetOldStudyRecordInfo`, {
    params,
  });
};
export const GetVideoNoteListByPage = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetVideoNoteListByPage`, {
    params,
  });
};
export const GetTeacherVideoStatisticsInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetTeacherVideoStatisticsInfo`, {
    params,
  });
};
export const GetVideoUrl = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/GetVideoUrl`, {
    params,
  });
};
export const AddVideoStudyRecordInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/AddVideoStudyRecordInfo`, params);
};
export const OverVideoInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/OverVideoInfo`, params);
};
export const AddVideoTimeInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/AddVideoTimeInfo`, params);
};
export const ManageGetTv_CateInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/ManageGetTv_CateInfo`, {
    params,
  });
};
export const ManageAddUpdateTv_CateInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/ManageAddUpdateTv_CateInfo`, params);
};
export const ManageDeleteTv_CateInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/ManageDeleteTv_CateInfo`, params);
};
export const ManageTv_TwoCateInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/ManageTv_TwoCateInfo`, {
    params,
  });
};
export const ManageAddUpdateTv_TwoCateInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/ManageAddUpdateTv_TwoCateInfo`, params);
};
export const ManageGetTv_VideoInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/ManageGetTv_VideoInfo`, {
    params,
  });
};
export const ManageGetTv_TwoCateInfo = (params) => {
  return axios.get(`${base}/api/mgd/TeacherVideo/ManageGetTv_TwoCateInfo`, {
    params,
  });
};
export const ManageDeleteTv_VideoInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/ManageDeleteTv_VideoInfo`, params);
};
export const ManageAddUpdateTv_VideoInfo = (params) => {
  return axios.post(`${base}/api/mgd/TeacherVideo/ManageAddUpdateTv_VideoInfo`, params);
};
export const GetFoodDayPeopleConsumeInfo = (params) => {
  return axios.get(`${base}/api/Food/GetFoodDayPeopleConsumeInfo`, {
    params,
  });
};
export const GetFoodDayPeoplEtraceElementInfo = (params) => {
  return axios.get(`${base}/api/Food/GetFoodDayPeoplEtraceElementInfo`, {
    params,
  });
};
export const GetMyDateInfo = (params) => {
  return axios.get(`${base}/sp/mgd/Sport/GetMyDateInfo`, {
    params,
  });
};
export const abnormalSportStudentList = (params) => {
  return axios.get(`${base}/sp/mgd/Sport/abnormalSportStudentList`, {
    params,
  });
};
export const abnormalSportStudentOther = (params) => {
  return axios.get(`${base}/sp/mgd/Sport/abnormalSportStudentOther`, {
    params,
  });
};
export const GetDateClassStuBaseInfo = (params) => {
  return axios.get(`${base}/sp/mgd/Sport/GetDateClassStuBaseInfo`, {
    params,
  });
};
export const DeleteDayRecipesInfo = (params) => {
  return axios.post(`${base}/api/Food/DeleteDayRecipesInfo`, params);
};
export const LookWeekDayRecipesInfo = (params) => {
  return axios.get(`${base}/api/Food/LookWeekDayRecipesInfo`, {
    params,
  });
};
export const GetTableTempFoodHorizontalRecipesInfo = (params) => {
  return axios.get(`${base}/api/Food/GetTableTempFoodHorizontalRecipesInfo`, {
    params,
  });
};
export const ExportWeekDayRecipesInfo = (params) => {
  return axios.get(`${base}/api/Food/ExportWeekDayRecipesInfo`, {
    params,
  });
};
export const ExportGetBookkeepingdietInfo = (params) => {
  return axios.get(`${base}/import/ImportInfo/ExportGetBookkeepingdietInfo`, {
    params,
  });
};
export const ExportGetMonthReportInfo = (params) => {
  return axios.get(`${base}/import/ImportInfo/ExportGetMonthReportInfo`, {
    params,
  });
};
export const ExportGetFoodDayPeoplEtraceElementInfo = (params) => {
  return axios.get(`${base}/import/ImportInfo/ExportGetFoodDayPeoplEtraceElementInfo`, {
    params,
  });
};
export const ExportGetFoodDayPeopleConsumeInfo = (params) => {
  return axios.get(`${base}/import/ImportInfo/ExportGetFoodDayPeopleConsumeInfo`, {
    params,
  });
};
export const GetManageTypeList = (params) => {
  return axios.get(`${base}/api/mgd/OneDaily/GetManageTypeList`, {
    params,
  });
};
export const SaveManageTypeList = (params) => {
  return axios.post(`${base}/api/mgd/OneDaily/SaveManageTypeList`, params);
};
export const GetMakeDetailInfo = (params) => {
  return axios.get(`${base}/api/mgd/Hx_Source/GetMakeDetailInfo`, {
    params,
  });
};
export const ClearGrowthResultInfo = (params) => {
  return axios.post(`${base}/api/mgd/EvalTerm/ClearGrowthResultInfo`, params);
};
export const GetShortCode = (params) => {
  return axios.get(`${base}/api/Login/GetShortCode`, {
    params,
  });
};
export const ExportGetPhysicalExaminationList = (params) => {
  return axios.get(`${base}/import/ImportInfo/ExportGetPhysicalExaminationList`, {
    params,
  });
};